import { getFolderDetails } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // STRINGS
      searchInsideFolder: "",
      searchInGroups: "",

      // ARRAYS
      userRoleSelected: [],

      // BOOLEAN
      listView: true,
      openTagUsers: false,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    ...mapGetters("teamsVUEX", {
      getExpand: "getExpand",
    }),
    ...mapGetters("teamsVUEX", {
      getActive: "getActive",
    }),
  },
  methods: {
    // GET ALL FOLDERS
    async getAllFolders() {
      try {
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          searchFolder: this.searchInGroups,
        };
        const response = await getFolderDetails(payload);
        if (response.status == 200) {
          this.$store.commit("teamsVUEX/setLoader", false);
          this.$store.commit("teamsVUEX/saveFolders", response.data.data.tree);
        }
      } catch (error) {
        this.$store.commit("teamsVUEX/setLoader", false);
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    // GET SPECIFIC FOLDER
    async getFolderDetails(folderId, flag) {
      try {
        this.$store.commit("teamsVUEX/setLoader", true);
        let userRoleString = this.userRoleSelected.join(",");
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          folderID: folderId,
          searchQuery: this.searchInsideFolder,
          userRole: userRoleString,
        };
        const response = await this.$store.dispatch(
          "teamsVUEX/getContent",
          payload
        );
        this.$store.commit("teamsVUEX/setLoader", false);
        if (flag) {
          this.folderUp = response;
          this.searchInsideFolder = "";
        }
      } catch (error) {
        this.$store.commit("teamsVUEX/setLoader", false);
        console.error(error);
      }
    },
  },
};
